<template>
  <div class="site-remote" :class="{ hide: closed }">
    <div class="close" @click="closeRemote">
      <div class="close-icon">{{ closed ? '❮' : '✕' }}</div>
    </div>

    <div class="content">
      <div class="remote-title">
        {{ $t('siteRemote.title') }}
      </div>

      <div class="sites-container" @scroll="scroll">
        <div v-for="site in targetSites" :key="site.id" class="site">
          <img class="icon-pin" :src="currentPin(site.order)" />
          <div class="title-container">
            <div class="title">
              {{ site.name }}
            </div>
            <div class="address">
              {{ site.address }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import assetProvider from '@/pure/assetProvider';
import { mapGetters } from 'vuex';
import { useSignalR } from '@dreamonkey/vue-signalr';

export default {
  name: 'SiteRemote',

  data() {
    return {
      closed: false,
      isScrolling: false,
      scrollTimeout: null,
      scrollIndex: 0,
    };
  },

  computed: {
    ...mapGetters({
      isDesktop: 'isDesktop',
      study: 'study',
      globalFilters: 'globalFilters',
    }),

    sites() {
      return this.study.sites ? this.study.sites : [];
    },

    targetSites() {
      return this.sites.filter(site => site.type === 'Target' && this.globalFilters.targetSites.includes(site.id));
    },

    displaySites() {
      this.scrollIndex;

      return [...this.targetSites].splice(this.scrollIndex, 4);
    },
  },

  created() {
    this.$socket = useSignalR();
  },

  methods: {
    closeRemote() {
      this.closed = !this.closed;
    },

    scroll(e) {
      this.isScrolling = true;
      clearTimeout(this.scrollTimeout);
      this.scrollTimeout = setTimeout(() => {
        this.isScrolling = false;
        this.scrollIndex = Math.round(e.target.scrollTop / 64);

        this.$socket.invoke('action', { action: 'tvScrollIndex', parameters: this.scrollIndex });
      }, 200);
    },

    currentPin(index) {
      return assetProvider[`poi${index + 1}`];
    },
  },
};
</script>

<style lang="scss" scoped>
@use '@/styles/colors.scss';

.site-remote {
  position: fixed;
  bottom: 416px;
  right: 0;
  z-index: 1;
  transition: all 0.6s ease;

  &.hide {
    right: -250px;
  }

  .close {
    position: absolute;
    z-index: 10;
    top: 16px;
    left: -28px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: colors.$red-color;
    width: 32px;
    height: 32px;
    border-radius: 4px 0 0 4px;
    color: colors.$white-color;
    font-size: 16px;
    box-shadow: 0 0 4px rgba(0, 0, 0, 0.3);
    transition: all 0.3s ease;
    cursor: pointer;

    .close-icon {
      transition: all 0.3s ease;
    }

    &:hover {
      left: -32px;

      .close-icon {
        transform: scale(1.2);
        opacity: 0.8;
      }
    }
  }

  .content {
    position: relative;
    z-index: 100;
    width: 256px;
    padding: 16px 0;
    background: colors.$white-color;
    border-radius: 4px 0 0 4px;
    box-shadow: 0 0 4px rgba(0, 0, 0, 0.3);
    box-sizing: border-box;

    .remote-title {
      font-style: italic;
      margin: 0 12px 16px;
    }

    .sites-container {
      max-height: 256px;
      overflow-y: auto;
      padding: 0 12px;
      scroll-snap-type: y mandatory;

      .site {
        display: flex;
        height: 64px;
        padding: 8px;
        border-bottom: 1px solid colors.$clear-border-color;
        scroll-snap-align: start;
        box-sizing: border-box;

        .icon-pin {
          height: 40px;
          width: auto;
          margin-left: -0.25em;
          margin-right: 0.5em;
        }

        .title-container {
          .title {
            width: 100%;
            font-weight: 700;
            font-size: 14px;
            color: colors.$navy-color;
          }

          .address {
            color: grey;
            font-size: 11px;
            font-weight: 400;
          }
        }
      }
    }
  }
}
</style>
